import { render, staticRenderFns } from "./ProjectDetailContractTab.vue?vue&type=template&id=1a188156&scoped=true&"
import script from "./ProjectDetailContractTab.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailContractTab.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailContractTab.vue?vue&type=style&index=0&id=1a188156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a188156",
  null
  
)

export default component.exports